'use client';

import React, {FC} from 'react';
import Image from 'next/image';

import styles from './styles.module.scss';

const Webinar: FC = () => (
  <div className={styles['section-webinar']}>
    <div className="default-container">
      <div className={styles.webinar}>
        <div>
          <h3 className={styles['webinar__title']}>
            Financial Resources <br /> <b>For Physicians</b>
          </h3>
          <p className={`${styles['webinar__info-text']} only-desktop`}>
            Healthcare professionals have a very unique financial situation.
            Their wealth potential is generally higher than other industries,
            but their financial circumstances involve more than just earnings
            and debt.
          </p>
        </div>
        <div className={styles.videoplayer}>
          <picture
            data-testid="webinar-picture"
            className={styles.videoplayer__image}>
            <Image
              className={styles['videoplayer__image_main-image']}
              src="/static/img/homepage/resources-img.jpg"
              alt="Your Health and Wealth Webinar"
              width="455"
              height="302"
            />
          </picture>
        </div>
        <p className={`${styles['webinar__info-text']} only-mobile`}>
          Healthcare professionals have a very unique financial situation. Their
          wealth potential is generally higher than other industries, but their
          financial circumstances involve more than just earnings and debt.
        </p>
      </div>
    </div>
  </div>
);

export default Webinar;
